module.exports = __webpack_public_path__ + "static/media/deltakere.787b4a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Om/static/deltakere.png
// module id = 154
// module chunks = 0